import { Checkbox, CircularProgress } from '@mui/material';
import { EnhancedDialog } from 'components/enhanced/dialog/EnhancedDialog';
import EnhancedForm from 'components/enhanced/form/EnhancedForm';
import { useTranslation } from 'react-i18next';
import { IResetResidualUnitsPreviewRow } from '../../types';

interface ResetResidualUnitsPreviewDialogProps {
  open: boolean;
  rows: IResetResidualUnitsPreviewRow[];
  selectedLineIds: number[];
  isLoadingPreview: boolean;
  isApplying: boolean;
  allSelected: boolean;
  onClose: () => void;
  onToggleLine: (lineId: number) => void;
  onSelectAll: () => void;
  onDeselectAll: () => void;
  onApply: () => void;
}

const ResetResidualUnitsPreviewDialog = ({
  open,
  rows,
  selectedLineIds,
  isLoadingPreview,
  isApplying,
  allSelected,
  onClose,
  onToggleLine,
  onSelectAll,
  onDeselectAll,
  onApply
}: ResetResidualUnitsPreviewDialogProps) => {
  const { t } = useTranslation();
  const prefix = 'pages.contract.resetResidualUnits';

  return (
    <EnhancedDialog
      open={open}
      onClose={onClose}
      title={t(`${prefix}.dialogTitle`)}
      submitLabel={t(`actions.confirm`)}
      cancelLabel={t(`actions.cancel`)}
      maxWidth="lg"
      isSubmitting={isApplying}
      isValid={!isLoadingPreview && rows.length > 0 && selectedLineIds.length > 0}
      submitButtonProps={{
        type: 'submit',
        form: 'resetResidualUnitsPreview',
        color: 'warning'
      }}>
      <EnhancedForm onSubmit={onApply} formId="resetResidualUnitsPreview" hideControls>
        {isLoadingPreview ? (
          <div className="py-8 flex justify-center">
            <CircularProgress size={28} />
          </div>
        ) : (
          <div className="space-y-3">
            <p>{t(`${prefix}.description`)}</p>
            {rows.length > 0 && (
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <Checkbox
                    checked={allSelected}
                    indeterminate={selectedLineIds.length > 0 && !allSelected}
                    onChange={allSelected ? onDeselectAll : onSelectAll}
                    size="small"
                  />
                  <span className="text-sm">
                    {allSelected ? t(`${prefix}.deselectAll`) : t(`${prefix}.selectAll`)}
                  </span>
                </div>
                <span className="text-sm text-gray-600">
                  {t(`${prefix}.selectedCount`, { count: selectedLineIds.length })}
                </span>
              </div>
            )}
            {rows.length === 0 && <p>{t(`${prefix}.noRows`)}</p>}
            {rows.map((row) => (
              <div key={row.id} className="border rounded p-2">
                <div className="flex items-center">
                  <Checkbox
                    checked={selectedLineIds.includes(row.id)}
                    onChange={() => onToggleLine(row.id)}
                    size="small"
                  />
                  <b>
                    {row.product} {row.warehouse ? `- ${row.warehouse}` : ''}
                  </b>
                </div>
                <div className="text-sm">
                  {t(`${prefix}.paymentLabel`)}:{' '}
                  {/* {t(`${prefix}.usedLabel`)} {row.before.used_units}{' '}{'->'} {row.after.used_units},  */}
                  {t(`${prefix}.availableLabel`)} {row.before.available_units} {'->'}{' '}
                  {row.after.available_units}
                </div>
                <div className="text-sm">
                  {t(`${prefix}.discountLabel`)}:{' '}
                  {/* {row.before.used_discounted_units} {'->'} {row.after.used_discounted_units},{' '} */}
                  {t(`${prefix}.availableLabel`)} {row.before.available_discounted_units} {'->'}{' '}
                  {row.after.available_discounted_units}
                </div>
              </div>
            ))}
          </div>
        )}
      </EnhancedForm>
    </EnhancedDialog>
  );
};

export default ResetResidualUnitsPreviewDialog;
